import qrcode from "qrcode-generator";

export const generateQr = (type: "v" | "d", code: string): string => {
  const scheme = `https://ppng.ir/${type}/${code}`;
  const typeNumber = 0;
  const errorCorrectionLevel = "M";
  const qr = qrcode(typeNumber, errorCorrectionLevel);
  qr.addData(scheme);
  qr.make();
  return qr.createDataURL(5);
};
